$ = require('jquery')

require('../class/sk')
require('../class/sk.widgets.Suggest')
require('../class/sk.widgets.SuggestMenu')

module.exports =
	init: (payload) ->
		{$target} = payload

		$target.find('.f-suggest').each(->
			$this = $(this)
			$input = $this.find('.f-suggest__inp')

			Suggest = new sk.widgets.Suggest($input,
				minLength: 2
				typeInterval: 250
				url: $this.data('suggest')
			)

			$menu = $('<div class="m-suggest"></div>').appendTo( $('.f-suggest__target') )

			SuggestMenu = new sk.widgets.SuggestMenu($menu, Suggest,
				'item': 'li'
			).init()

			$(SuggestMenu)
				.on('menuselect', ->
					$item = this.$items.eq( this.selectedIndex-1 )

					if $this.hasClass('f-availability')
						$input.val($item.text())
					else
						window.location = $item.find('a').attr('href')
				)
				.on('beforeopen', ->
					$input.addClass('is-suggested')
				)
				.on('beforehide', ->
					$input.removeClass('is-suggested')
				)

			return
		)

		return



// WEBPACK FOOTER //
// ./src/js/components/suggest.coffee